// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-text-field .v-input__control input {\r\n  font-size: 12px;\n}\n.custom-text-field .v-input__control label {\r\n  font-size: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
